<template>
  <v-data-table :headers="headers" :items="users" :search="textFilter" :custom-filter="customFilter"
    @click:row="selectUser" class="elevation-1">
    <template v-slot:[`item.actions`]="{ item }">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon color="primary" dark>
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="action('delete', item)">Delete</v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>
<script>
export default {
  name: "UserList",
  props: ["textFilter"],
  data() {
    return {
      headers: [
        { text: "First name", value: "firstName" },
        { text: "Last name", value: "lastName" },
        { text: "Title", value: "title" },
        { text: "Organisation", value: "organization" },
        { text: "Email", value: "email" },
        { text: "Area(s)", value: "combinedAreas" },
        { text: "", value: "actions" }
      ],
    };
  },
  mounted() {
    this.$store.dispatch("dispatchGetUsers").then(() => {
      if (this.$route.query.userId) {
        let userId = this.$route.query.userId;
        let user = this.users.find(user => user.id == userId);
        this.selectUser(user);
      }
    });
  },
  methods: {
    selectUser(user) {
      console.log(user);
      this.$emit("selectUser", user);
    },
    action(action, user) {
      if (action == 'delete') {
        this.$emit('deleteUser', user.id);
      }
    },
    customFilter(value, search, item) {
      if (search && search !== "") {
        const searchText = search.toLowerCase();
        return (
          item.firstName.toLowerCase().includes(searchText) ||
          item.lastName.toLowerCase().includes(searchText) ||
          item.title.toLowerCase().includes(searchText) ||
          item.organization.toLowerCase().includes(searchText) ||
          item.email.toLowerCase().includes(searchText) ||
          (item.combinedAreas && item.combinedAreas.toLowerCase().includes(searchText))
        );
      }
    },
  },
  computed: {
    users() {
      return this.$store.state.users.map((user) => {
        if (user.areas) {
          user["combinedAreas"] = user.areas
            .map((area) => {
              return area.name;
            })
            .join(", ");
        }
        if (user.roles) {
          user["combinedRoles"] = user.roles
            .map((role) => {
              return role.name;
            })
            .join(", ");
        }
        return user;
      });
    },
  },
};
</script>
<style scoped>
.v-data-table {
  width: 100%;
}
</style>